import { useFormContext } from "react-hook-form";

import { SendLeadFormValues } from "@/app/(main)/(club)/mes-clubs/[id]/leads/schemas/schema";
import { SendTestimonyFormValues } from "@/app/(main)/(club)/mes-clubs/[id]/temoignages/schemas/schema";
import { ProfileFormValues } from "@/app/(security)/inscription/schemas/schema";
import { InputError } from "@/components/global/form/inputs/input-error";

type SupportedSchemas =
  ProfileFormValues | SendLeadFormValues | SendTestimonyFormValues;

interface InputStyles {
  marginTop?: string;
}

interface WrapperStyles {
  position?: "start" | "center";
}

interface CheckboxStyles {
  wrapper?: WrapperStyles;
  input?: InputStyles;
  label?: string;
}

interface CheckboxProps {
  labelStart?: string;
  linkText?: string;
  linkHref?: string;
  id?: string;
  name?: string;
  styles?: CheckboxStyles;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  labelStart,
  linkText,
  linkHref,
  id = "cgu",
  name = "cgu" as const,
  styles = {
    wrapper: {
      position: "center",
    },
    input: {
      marginTop: "mt-0",
    },
  },
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SupportedSchemas>();

  return (
    <div className="w-full relative">
      <div className={`flex items-${styles?.wrapper?.position}`}>
        <input
          type="checkbox"
          id={id}
          {...register(name as keyof SupportedSchemas, {
            required: "Vous devez accepter les CGU",
          })}
          className={`accent-primary mr-2 cursor-pointer ${styles?.input?.marginTop}`}
          data-cy={id}
        />
        <label
          htmlFor={id}
          className={`text-sm cursor-pointer ${styles?.label}`}
        >
          {labelStart}{" "}
          {linkText && (
            <a
              href={linkHref}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-4"
              onClick={(e) => e.stopPropagation()}
            >
              {linkText}
            </a>
          )}
        </label>
      </div>
      {errors[name as keyof SupportedSchemas] && (
        <InputError
          error={errors[name as keyof SupportedSchemas]?.message || ""}
        />
      )}
    </div>
  );
};
